import axios from '../config/axios'

export const login = (data)=> axios.post('/login', data)
export const logout = ()=> axios.post('/logout')